import { JSX } from 'preact'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { useTemplateTags } from '../useTemplateTags'
import { useFormContext } from '../Form/useFormContext'
import { useComponentStyle } from '../Style'

export function TextArea({ name, placeholder, required, ...props }: TBlockProps<BlockType.Textarea>): JSX.Element {
  const { template } = useTemplateTags()
  const { getValue, setValue } = useFormContext()
  const { classes } = useComponentStyle('input-textarea', props)
  const value = getValue(name)
  const className = classnames(classes, { filled: !!value })

  const handleInput = (e: Event) =>
    setValue(name, {
      value: [(e.target as HTMLInputElement).value], // see https://github.com/preactjs/preact/issues/1930
    })

  return (
    <textarea
      className={className}
      name={name}
      rows={4}
      placeholder={template(placeholder)}
      value={value}
      onInput={handleInput}
      required={required}
    />
  )
}
